// 访客标识属于浏览器存储环境，不用于推断跨无痕窗口的真实用户。
const storageKey = 'aidh_rtc_device_id';
const randomId = () => {
  try {
    const bytes = new Uint8Array(20);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, value => (value % 36).toString(36)).join('');
  } catch {
    return Array.from({ length: 20 }, () => Math.floor(Math.random() * 36).toString(36)).join('');
  }
};
const pageViewId = randomId();
let deviceId = '', scope = 'page-memory';

export function getBrowserDiagnosticIdentity() {
  if (!deviceId) {
    try {
      deviceId = window.localStorage.getItem(storageKey) || '';
      if (!deviceId) {
        deviceId = randomId();
        window.localStorage.setItem(storageKey, deviceId);
      }
      scope = 'browser-storage';
    } catch { deviceId ||= randomId(); }
  }
  return { device_id: deviceId, device_id_scope: scope, page_view_id: pageViewId };
}
